export enum DisclaimerEditFormFields {
  name = 'name',
  disclaimer = 'disclaimer',
  titles = 'titles',
}

export type DisclaimerEditFormValues = {
  [DisclaimerEditFormFields.name]: string;
  [DisclaimerEditFormFields.disclaimer]: string;
  [DisclaimerEditFormFields.titles]: (string | null)[];
};
